'use strict';

var JSConstants = require('_core_ext/pages/tradecard/constants');

function prefillAddress () {
    function getEmptyValuesInput(selector) {
        return $(selector).filter(function() { return this.value === ''; });
    }

    $(JSConstants.ADDRESS_MANUAL_TITLE + ':has(option[value=""]:selected)').val($(JSConstants.TITLE).val());
    getEmptyValuesInput(JSConstants.ADDRESS_MANUAL_FIRST_NAME).val($(JSConstants.FIRST_NAME).val());
    getEmptyValuesInput(JSConstants.ADDRESS_MANUAL_LAST_NAME).val($(JSConstants.LAST_NAME).val());
    getEmptyValuesInput(JSConstants.ADDRESS_MANUAL_PHONE).val($(JSConstants.PHONE).val());
}

module.exports = prefillAddress;